import React, { Component } from 'react';

class PageHeader extends Component {
  render() {
    const { children, color } = this.props;
    let textColor = color ? color : 'white';
    return (
      <h1 style={{ color: textColor, fontSize: 40, marginLeft: 150 }}>{children}</h1>
    );
  }
}

export { PageHeader };


// WEBPACK FOOTER //
// ./src/components/PageHeader.js